export default "__VITE_ASSET__BphMqBWk__"